module.exports = __webpack_public_path__ + "img/kiosk-inventory-shopping-mall.2682be7d.webp";